/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceName } from './ServiceName';
import {
    ServiceNameFromJSON,
    ServiceNameFromJSONTyped,
    ServiceNameToJSON,
    ServiceNameToJSONTyped,
} from './ServiceName';

/**
 * 
 * @export
 * @interface PaginatedServiceNameList
 */
export interface PaginatedServiceNameList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedServiceNameList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedServiceNameList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedServiceNameList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ServiceName>}
     * @memberof PaginatedServiceNameList
     */
    results: Array<ServiceName>;
}

/**
 * Check if a given object implements the PaginatedServiceNameList interface.
 */
export function instanceOfPaginatedServiceNameList(value: object): value is PaginatedServiceNameList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedServiceNameListFromJSON(json: any): PaginatedServiceNameList {
    return PaginatedServiceNameListFromJSONTyped(json, false);
}

export function PaginatedServiceNameListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedServiceNameList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ServiceNameFromJSON)),
    };
}

  export function PaginatedServiceNameListToJSON(json: any): PaginatedServiceNameList {
      return PaginatedServiceNameListToJSONTyped(json, false);
  }

  export function PaginatedServiceNameListToJSONTyped(value?: PaginatedServiceNameList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(ServiceNameToJSON)),
    };
}

